import { useIsMobileHook } from '@teliaee/telia-common-components';
import { inject, observer } from 'mobx-react';
import { useContext } from 'react';
import * as React from 'react';
import { LargeSearch, SuggestionField } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import AddressStore, { Address, Room } from '../stores/AddressStore';
import AddressAutocompleteStore from '../stores/AddressAutocompleteStore';

interface AddressAutocompleteProps {
  onSubmit?: (address: Address, room: Room) => void;
  labelsPrefix?: string;
  roomLabel?: string;
  addressStore?: AddressStore;
  addressAutocompleteStore?: AddressAutocompleteStore;
}

const AddressAutocomplete = (props: AddressAutocompleteProps) => {
  const translate = useContext(TranslationsContext).translate;
  const { isMobile } = useIsMobileHook();

  const { labelsPrefix, addressAutocompleteStore, roomLabel } = props;
  const labelPrefix = labelsPrefix ? `${labelsPrefix}.` : '';

  const doSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    if (event) {
      event.preventDefault();
    }
    addressAutocompleteStore.handleApartmentNotice();
    if (props.onSubmit && !addressAutocompleteStore.isApartmentInvalid) {
      if (addressAutocompleteStore.selectedAddress) {
        props.onSubmit(addressAutocompleteStore.selectedAddress, addressAutocompleteStore.findRoom());
      } else {
        addressAutocompleteStore.error = 'selectFromSuggestions';
      }
    }
    document.getElementById('address-search')?.focus();
  };

  return (
    <>
      <LargeSearch
        id="address-search"
        className="text__margin text-normal"
        align="center"
        onSubmit={doSubmit}
        helper={
          addressAutocompleteStore.error
            ? {
                type: 'error',
                text: translate(`addressAutocomplete.error.${addressAutocompleteStore.error}`)
              }
            : null
        }
        formAttributes={{ tabIndex: -1 }}
      >
        <SuggestionField
          id="address-field"
          value={addressAutocompleteStore.addressText}
          label={translate(`${labelPrefix}addressAutocomplete.address${isMobile ? '.shorterForMobile' : ''}`)}
          items={addressAutocompleteStore.suggestions}
          onChange={addressAutocompleteStore.onAddressAutocompleteChange}
          onSelect={(item) => addressAutocompleteStore.onAddressAutocompleteSelectAddress(item)}
          isClearable
          onClear={addressAutocompleteStore.clearAddress}
        />
        <SuggestionField
          id="apartment-field"
          value={addressAutocompleteStore.roomText}
          label={translate(roomLabel ? roomLabel : `${labelPrefix}addressAutocomplete.room`)}
          items={addressAutocompleteStore.roomSuggestions}
          onChange={addressAutocompleteStore.onRoomAutocompleteChange}
          onFocus={addressAutocompleteStore.onAddressAutocompleteFocus}
          showSuggestionsOnFocus={true}
          inputRef={(element: HTMLInputElement | HTMLTextAreaElement) => {
            if (element && !addressAutocompleteStore.roomField) {
              addressAutocompleteStore.roomField = element;
            }
          }}
        />
      </LargeSearch>
    </>
  );
};

export default inject('addressStore', 'addressAutocompleteStore')(observer(AddressAutocomplete));
